import { UAParser } from "ua-parser-js";
import { BoomIdLogo } from "./icons/boom-id-logo";
import { FunIdLogo } from "./icons/fun-id-logo";
import { addQueryParams, getPlatformType, isDevEnvironment, replaceSecondLevelDomain } from "./utils";
import { Platform } from "./models";
import { appendMarketingParamsToUrl } from "./affiliate-config";

const devices: Record<Platform, { ios: string; android: string }> = {
  [Platform.PlayId]: {
    ios: "https://playid.onelink.me/1k23/kxn5gn5e",
    android: "https://playid.onelink.me/1k23/kxn5gn5e",
  },
  [Platform.FunId]: {
    ios: "https://playid.onelink.me/1k23/kxn5gn5e",
    android: "https://playid.onelink.me/1k23/kxn5gn5e",
  },
  [Platform.BoomId]: {
    ios: "itms-apps://itunes.apple.com/app/apple-store/id6749531755",
    android: "https://onepass.app/download/apk",
  },
  [Platform.OnePass]: {
    ios: "itms-apps://itunes.apple.com/app/apple-store/id6749531755",
    android: "https://onepass.app/download/apk",
  },
  [Platform.Default]: {
    ios: "https://playid.onelink.me/1k23/kxn5gn5e",
    android: "https://playid.onelink.me/1k23/kxn5gn5e",
  },
};

export function DownloadApplicationLink(): string {
  const platform = getPlatformType() as Platform;

  const appleVendor = "Apple";
  const userAgent = UAParser(navigator.userAgent);

  const isApple = userAgent.device.vendor === appleVendor;

  const raw = isApple
    ? (devices[platform] ?? devices[Platform.Default]).ios
    : (devices[platform] ?? devices[Platform.Default]).android;
  return appendMarketingParamsToUrl(raw);
}

const marketplaceIcon: Record<Platform, typeof FunIdLogo | typeof BoomIdLogo> = {
  [Platform.PlayId]: FunIdLogo,
  [Platform.FunId]: FunIdLogo,
  [Platform.BoomId]: BoomIdLogo,
  [Platform.OnePass]: BoomIdLogo,
  [Platform.Default]: FunIdLogo,
};
const marketplaceBgColor: Record<Platform, string> = {
  [Platform.PlayId]: "#F8F8FB",
  [Platform.FunId]: "#F8F8FB",
  [Platform.BoomId]: "#F8F8FB",
  [Platform.OnePass]: "#F8F8FB",
  [Platform.Default]: "#F8F8FB",
};
const marketplaceName: Record<Platform, string> = {
  [Platform.PlayId]: "PlayID",
  [Platform.FunId]: "PlayID",
  [Platform.BoomId]: "OnePass",
  [Platform.OnePass]: "OnePass",
  [Platform.Default]: "PlayID",
};
const onelinkUrl: Record<Platform, string> = {
  [Platform.PlayId]: "https://playid.onelink.me/1k23/rn5ebkzo",
  [Platform.FunId]: "https://playid.onelink.me/1k23/rn5ebkzo",
  [Platform.BoomId]: "https://onepass.onelink.me/6A7r/slomsiiw",
  [Platform.OnePass]: "https://onepass.onelink.me/6A7r/slomsiiw",
  [Platform.Default]: "https://playid.onelink.me/1k23/rn5ebkzo",
};
const onelinkDevUrl: Record<Platform, string> = {
  [Platform.PlayId]: "https://playid-dev.onelink.me/AGUV/leb7fjsh",
  [Platform.FunId]: "https://playid-dev.onelink.me/AGUV/leb7fjsh",
  [Platform.BoomId]: "https://onepass.onelink.me/6A7r/slomsiiw",
  [Platform.OnePass]: "https://onepass.onelink.me/6A7r/slomsiiw",
  [Platform.Default]: "https://playid-dev.onelink.me/AGUV/leb7fjsh",
};
const fidplatformUrl: Record<Platform, string> = {
  [Platform.PlayId]: "playid.com",
  [Platform.FunId]: "playid.com",
  [Platform.BoomId]: "onepass.app",
  [Platform.OnePass]: "onepass.app",
  [Platform.Default]: "playid.com",
};
const marketplaceFavicon: Record<Platform, string> = {
  [Platform.PlayId]: "https://playid.com/favicon.ico",
  [Platform.FunId]: "https://playid.com/favicon.ico",
  [Platform.BoomId]: "https://onepass.app/favicon.png",
  [Platform.OnePass]: "https://onepass.app/favicon.png",
  [Platform.Default]: "https://playid.com/favicon.ico",
};

export const WIDGET_LOCALIZATION_CONTENT_SLUG = "keyspaymentmodal";
export const WIDGET_CARDS_CONTENT_SLUG = "paymentmodal";

export function MarketplaceIcon() {
  return marketplaceIcon[getPlatformType()] ?? marketplaceIcon[Platform.Default];
}

export function GetBgColor() {
  return marketplaceBgColor[getPlatformType()] ?? marketplaceBgColor[Platform.Default]
}

export function MarketplaceName() {
  return marketplaceName[getPlatformType()] ?? marketplaceName[Platform.Default];
}

export function MarketplaceFavicon() {
  return marketplaceFavicon[getPlatformType()] ?? marketplaceFavicon[Platform.Default];
}

export function OnelinkUrl() {
  return (isDevEnvironment()
    ? onelinkDevUrl[getPlatformType()]
    : onelinkUrl[getPlatformType()]
  ) ?? onelinkUrl[Platform.Default];
}

export function FidPlatformUrl() {
  return fidplatformUrl[getPlatformType()] ?? fidplatformUrl[Platform.Default];
}

export function getQrUrl(): string {
  const url = replaceSecondLevelDomain(window.location.href, FidPlatformUrl());
  const autoOpenedUrl = addQueryParams(url, { noapp: true });

  return appendMarketingParamsToUrl(autoOpenedUrl);
}

export function PlatformCMSUrl() {
  const platformUrl = FidPlatformUrl();
  const cmsApiUrl = `//content.${platformUrl}`;

  return cmsApiUrl;
}
